import React, { useEffect } from 'react';
import { initMetaPixel } from './utils/metaPixel';
import { UrgencyBar } from './components/UrgencyBar';
import { Hero } from './components/Hero';
import { Gallery } from './components/Gallery';
import { Pain } from './components/Pain';
import { MethodIntro } from './components/MethodIntro';
import { Offer } from './components/Offer';
import { Preview } from './components/Preview';
import { Skills } from './components/Skills';
import { ValueStack } from './components/ValueStack';
import { Testimonials } from './components/Testimonials';
import { Pricing } from './components/Pricing';
import { Faq } from './components/Faq';
import { Guarantee } from './components/Guarantee';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen w-full bg-cream font-sans" data-id="element-0" data-mp="28t4l0cwhy8sh">
      <UrgencyBar data-id="element-1" data-mp="23vkzqt1dsvr1" />
      <main data-id="element-2" data-mp="23w4c7u89irxo">
        <Hero data-id="element-3" data-mp="23ujmchww7x65" />
        <Gallery data-id="element-4" data-mp="23v2r0wxj8p28" />
        <Pain data-id="element-5" data-mp="23ti8k5ohswkq" />
        <MethodIntro data-id="element-6" data-mp="3ijxsgzk2wgo4" />
        <Offer data-id="element-7" data-mp="3ikr0s4yore8d" />
        <Preview data-id="element-8" data-mp="3ij652c0mxp8x" />
        <Skills data-id="element-9" data-mp="3ijpbowku4r7n" />
        <ValueStack data-id="element-10" data-mp="3ihuyy5jpw5en" />
        <Testimonials data-id="element-11" data-mp="3mlavl1vse5rc" />
        <Pricing data-id="element-12" data-mp="3mkrcviybbdc9" />
        <Faq data-id="element-13" data-mp="3mk84otygs3bf" />
        <Guarantee data-id="element-14" data-mp="3mjq2lgp4euvl" />
      </main>
      <Footer data-id="element-15" data-mp="3rc9co3oln7vn" />
    </div>;
}